import { composeTheme } from '../../utils/compose-theme'
import { defaultTheme } from '../../theming/data/defaultTheme'
import colors from '../../tokens/colors'
import fonts from '../../tokens/fonts'
import styled from 'styled-components'

export const ActionButton = styled.div.attrs((props) => composeTheme(props))`
  align-items: center;
  border-radius: ${(props) => props.theme.snackbar.actionButton.borderRadius};
  border: ${(props) => props.theme.snackbar.actionButton.border};
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.snackbar.actionButton.fontSize};
  font-style: normal;
  font-weight: ${(props) => props.theme.snackbar.actionButton.fontWeight};
  justify-content: center;
  line-height: ${(props) => props.theme.snackbar.actionButton.fontHeight};
  margin-left: ${(props) => props.theme.snackbar.actionButton.marginLeft};
  padding: ${(props) => props.theme.snackbar.actionButton.padding};
  white-space: nowrap;

  &:hover {
    background-color: transparent;
  }

  &.neutral {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.neutralColor.highPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.neutralColor.highPriority.actionButtonColor};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.neutralColor.lowPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.neutralColor.lowPriority.actionButtonColor};
    }
  }

  &.negative {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.negativeColor.highPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.negativeColor.highPriority.actionButtonColor};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.negativeColor.lowPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.negativeColor.lowPriority.actionButtonColor};
    }
  }

  &.warning {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.warningColor.highPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.warningColor.highPriority.actionButtonColor};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.warningColor.lowPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.warningColor.lowPriority.actionButtonColor};
    }
  }

  &.positive {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.positiveColor.highPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.positiveColor.highPriority.actionButtonColor};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.positiveColor.lowPriority
          .actionButtonBackgroundColor};
      color: ${(props) =>
        props.theme.snackbar.positiveColor.lowPriority.actionButtonColor};
    }
  }

  &:focus {
    outline: none;
  }
`

export const Alert = styled.div.attrs((props) => composeTheme(props))`
  @keyframes appear {
    0% {
      transform: translateY(2rem);
      opacity: 0;
    }

    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }

  align-items: center;
  animation: 0.2s ease-out 0s 1 appear;
  border-radius: ${(props) => props.theme.snackbar.borderRadius};
  border: ${(props) => props.theme.snackbar.border};
  box-shadow: ${(props) => props.theme.snackbar.boxShadow};
  display: flex;
  font-family: ${fonts.inter};
  font-size: ${(props) => props.theme.snackbar.fontSize};
  font-style: normal;
  font-weight: ${(props) => props.theme.snackbar.fontWeight};
  justify-content: space-between;
  line-height: ${(props) => props.theme.snackbar.fontHeight};
  padding: ${(props) => props.theme.snackbar.padding};
  width: fit-content;

  &.neutral {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.neutralColor.highPriority.backgroundColor};
      border-color: ${(props) =>
        props.theme.snackbar.neutralColor.highPriority.borderColor};
      color: ${(props) => props.theme.snackbar.neutralColor.highPriority.color};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.neutralColor.lowPriority.backgroundColor};
      border: ${(props) =>
        props.theme.snackbar.neutralColor.lowPriority.border};
      color: ${(props) => props.theme.snackbar.neutralColor.lowPriority.color};
    }
  }

  &.negative {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.negativeColor.highPriority.backgroundColor};
      border-color: ${(props) =>
        props.theme.snackbar.negativeColor.highPriority.borderColor};
      color: ${(props) =>
        props.theme.snackbar.negativeColor.highPriority.color};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.negativeColor.lowPriority.backgroundColor};
      border: ${(props) =>
        props.theme.snackbar.negativeColor.lowPriority.border};
      color: ${(props) => props.theme.snackbar.negativeColor.lowPriority.color};
    }
  }

  &.warning {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.warningColor.highPriority.backgroundColor};
      border-color: ${(props) =>
        props.theme.snackbar.warningColor.highPriority.borderColor};
      color: ${(props) => props.theme.snackbar.warningColor.highPriority.color};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.warningColor.lowPriority.backgroundColor};
      border: ${(props) =>
        props.theme.snackbar.warningColor.lowPriority.border};
      color: ${(props) => props.theme.snackbar.warningColor.lowPriority.color};
    }
  }

  &.positive {
    &.high-priority {
      background-color: ${(props) =>
        props.theme.snackbar.positiveColor.highPriority.backgroundColor};
      border-color: ${(props) =>
        props.theme.snackbar.positiveColor.highPriority.borderColor};
      color: ${(props) =>
        props.theme.snackbar.positiveColor.highPriority.color};
    }
    &.low-priority {
      background-color: ${(props) =>
        props.theme.snackbar.positiveColor.lowPriority.backgroundColor};
      border: ${(props) =>
        props.theme.snackbar.positiveColor.lowPriority.border};
      color: ${(props) => props.theme.snackbar.positiveColor.lowPriority.color};
    }
  }
`
export const CloseButton = styled.div.attrs((props) => composeTheme(props))`
  cursor: pointer;
  margin-left: ${(props) => props.theme.snackbar.closeButtonMarginLeft};
`

export const Text = styled.div.attrs((props) => composeTheme(props))`
  margin-left: ${(props) => props.theme.snackbar.textMarginLeft};
  max-width: ${(props) => props.theme.snackbar.textMaxWidth};
`

export const Wrapper = styled.div.attrs((props) => composeTheme(props))`
  bottom: ${(props) => props.theme.snackbar.position.bottom};
  display: flex;
  height: fit-content;
  justify-content: flex-start;
  left: ${(props) => props.theme.snackbar.position.left};
  position: fixed;
  right: ${(props) => props.theme.snackbar.position.right};
  top: ${(props) => props.theme.snackbar.position.top};
  z-index: 1900;
`

ActionButton.defaultProps = defaultTheme
Alert.defaultProps = defaultTheme
CloseButton.defaultProps = defaultTheme
Text.defaultProps = defaultTheme
Wrapper.defaultProps = defaultTheme
